import { ApolloClient } from 'apollo-client';
import { createContext } from 'react';
import { ErrorType } from 'store/errorHandler/types';
import { Permissions, User } from 'components/User/types';
import { History } from 'history';
import { PostHog } from 'posthog-js';

export type Versioning = {
  uuid: string;
  lastUpdate: number;
};

export type LoginSession = {
  user: User | null;
  access_token: string;
  permissions: Permissions | null;
};

type ApplicationContextType = {
  apolloClient: ApolloClient<object>;
  errorHandler: {
    push: (errors: ErrorType[]) => void;
    reset: () => void;
    errors: ErrorType[];
  };
  isbToken: string | null;
  isbUser: string | null;
  logout: () => void;
  permissions: Permissions | null;
  permissionsIsLoading: boolean;
  setIsbToken: (isbToken: string) => void;
  setIsbUser: (isbUser: string) => void;
  setPermissions: (permissions: Permissions) => void;
  setSession: (loginSession: LoginSession) => void;
  setToken: (token: string) => void;
  setUser: (user: User) => void;
  setVersioning: (version: Versioning | null) => void;
  token: string | null;
  user: User | null;
  versioning: Versioning | null;
  history: History | null;
  postHog: PostHog | null;
  loadUser: (arg0?: User | null) => void;
};

const ApplicationContext = createContext<ApplicationContextType>({
  apolloClient: null,
  errorHandler: {
    push: () => {},
    reset: () => {},
    errors: [],
  },
  isbToken: null,
  isbUser: null,
  logout: () => {},
  permissions: null,
  permissionsIsLoading: false,
  setIsbToken: () => {},
  setIsbUser: () => {},
  setPermissions: () => {},
  setSession: () => {},
  setToken: () => {},
  setUser: () => {},
  setVersioning: () => {},
  token: null,
  user: null,
  versioning: null,
  history: null,
  postHog: null,
  loadUser: () => null,
});

export default ApplicationContext;
